var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SidebarFilterBadgesContainer,{attrs:{"allFilters":_setup.filteredCrops,"activeFilters":_vm.activeFilters,"emptyFilterLabel":_vm.$t('Keine Kultur')},on:{"update:filter":(filterName) => _vm.$emit('update:filter', filterName)}})
}
var staticRenderFns = []

export { render, staticRenderFns }